// extracted by mini-css-extract-plugin
export default {"btn-sort-order":"SortBy_btn-sort-order__bThlN","btn-icon":"SortBy_btn-icon__6MhAi","btn-sort-style-small":"SortBy_btn-sort-style-small__eGe1C"};